import api from './index';
import { Brand, BrandEditForm, BrandForm } from '../types/Brand.interface';

const BASE = '/brands';

export const getBrands = async (params: { withDataStats?: boolean } = {}) => {
    return api.get<Brand[]>(BASE, { params }).then((res) => res.data);
};

export const createBrand = async (data: BrandForm) => {
    return api.post<Brand>(`${BASE}`, data).then((res) => res.data);
};

export const updateBrand = async ({ id, ...data }: BrandEditForm) => {
    return api.patch<Brand>(`${BASE}/${id}`, data).then((res) => res.data);
};

export const deleteBrand = async (id: number) => {
    return api.delete<{ success: boolean }>(`${BASE}/${id}`).then((res) => res.data);
};
